<template>
  <div class="main">
    <div class="title">
      <span>{{ $t('shopListPage.title') }}</span>
      <a-button
        :loading="loading"
        type="primary"
        style="
          flex: 0 1 auto;
          height: 38px;
          width: 140px;
          background: #2ca70e;
          border-color: #2ca70e;
          margin-left: auto;
        "
        v-on:click="downloadCsv()"
        >{{ $t('component.TimeM.exportExcel') }}</a-button
      >
    </div>
    <div v-if="$store.getters.get_notMobileView" class="list-style">
      <ul class="list-header">
        <li>{{ $t('shopListPage.shopList.code') }}</li>
        <li>{{ $t('shopListPage.shopList.enName') }}</li>
        <li>{{ $t('shopListPage.shopList.chName') }}</li>
        <li style="flex: 0 0 10%">{{ $t('shopListPage.shopList.type') }}</li>
        <li>{{ $t('shopListPage.shopList.locationMall') }}</li>
        <li>{{ $t('shopListPage.shopList.locationStation') }}</li>
        <li style="flex: 0 0 10%">
          {{ $t('shopListPage.shopList.acceptEvoucher') }}
        </li>
      </ul>
      <div
        v-for="item in dataResult"
        :key="item.id"
        :class="selected(item.DetailData.length, item.isShowDetailData)"
      >
        <ul @click="showDetail(item.id, item.ShopCode)">
          <li>{{ item.ShopCode }}</li>
          <li>{{ item.ShopNameEN }}</li>
          <li>{{ item.ShopNameCH }}</li>
          <li style="flex: 0 0 10%">{{ item.ShopType }}</li>
          <li>{{ item.ShopLocationMall }}</li>
          <li>{{ item.ShopLocationStation }}</li>
          <li style="flex: 0 0 10%">{{ item.AcceptEvoucher }}</li>
        </ul>
        <div v-if="item.DetailData.length > 0 && item.isShowDetailData == '1'">
          <ul class="list-header">
            <li>{{ $t('shopListPage.contactList.firstName') }}</li>
            <li>{{ $t('shopListPage.contactList.lastName') }}</li>
            <li>{{ $t('shopListPage.contactList.email') }}</li>
            <li>{{ $t('shopListPage.contactList.contactType') }}</li>
            <li>{{ $t('shopListPage.contactList.shopCode') }}</li>
            <li>{{ $t('shopListPage.contactList.salutation') }}</li>
            <li>{{ $t('shopListPage.contactList.title') }}</li>
            <li>{{ $t('shopListPage.contactList.phone') }}</li>
            <li>{{ $t('shopListPage.contactList.mobile') }}</li>
            <li>{{ $t('shopListPage.contactList.receiveUsageReport') }}</li>
            <li>{{ $t('shopListPage.contactList.status') }}</li>
          </ul>
          <div>
            <ul v-for="d in item.DetailData" :key="d.id">
              <li>{{ d.firstName }}</li>
              <li>{{ d.lastName }}</li>
              <li>{{ d.email }}</li>
              <li>{{ d.contactType }}</li>
              <li>{{ d.shopCode }}</li>
              <li>{{ d.salutation }}</li>
              <li>{{ d.title }}</li>
              <li>{{ d.phone }}</li>
              <li>{{ d.mobile }}</li>
              <li>{{ d.receiveUsageReport }}</li>
              <li>{{ d.status }}</li>
            </ul>
            <ul
              class="closeDetail"
              style="min-height: 35px"
              @click="showDetail(item.id)"
            >
              <li>{{ $t('shopListPage.contactList.hide') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="list-style-mobile"
      v-for="item in dataResult"
      :key="item.id"
    >
      <ul @click="showDetail(item.id, item.ShopCode)">
        <li>
          <span>{{ $t('shopListPage.shopList.code') }}</span>
          <span>{{ item.ShopCode }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.enName') }}</span>
          <span>{{ item.ShopNameEN }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.chName') }}</span>
          <span>{{ item.ShopNameCH }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.type') }}</span>
          <span>{{ item.ShopType }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.locationMall') }}</span>
          <span>{{ item.ShopLocationMall }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.locationStation') }}</span>
          <span>{{ item.ShopLocationStation }}</span>
        </li>
        <li>
          <span>{{ $t('shopListPage.shopList.acceptEvoucher') }}</span>
          <span>{{ item.AcceptEvoucher }}</span>
        </li>
        <div
          v-if="item.DetailData.length > 0 && item.isShowDetailData == '1'"
          class="list-style-mobile contactDetailDiv"
        >
          <ul
            v-for="d in item.DetailData"
            :key="d.id"
            style="margin: 10px auto"
          >
            <li>
              <span>{{ $t('shopListPage.contactList.firstName') }}</span>
              <span>{{ d.firstName }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.lastName') }}</span>
              <span>{{ d.lastName }}</span>
            </li>
            <li>
              <span> {{ $t('shopListPage.contactList.email') }}</span>
              <span>{{ d.email }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.contactType') }} </span>
              <span>{{ d.contactType }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.shopCode') }}</span>
              <span>{{ d.shopCode }}</span>
            </li>
            <li>
              <span> {{ $t('shopListPage.contactList.salutation') }}</span>
              <span>{{ d.salutation }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.title') }}</span>
              <span>{{ d.title }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.phone') }} </span>
              <span>{{ d.phone }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.mobile') }}</span>
              <span>{{ d.mobile }}</span>
            </li>
            <li>
              <span>{{
                $t('shopListPage.contactList.receiveUsageReport')
              }}</span>
              <span>{{ d.receiveUsageReport }}</span>
            </li>
            <li>
              <span>{{ $t('shopListPage.contactList.status') }} </span>
              <span>{{ d.status }}</span>
            </li>
          </ul>
          <ul
            class="closeDetail"
            style="min-height: 35px"
            @click.stop="showDetail(item.id)"
          >
            <li>{{ $t('shopListPage.contactList.hide') }}</li>
          </ul>
        </div>
      </ul>
    </div>
  </div>
</template>
<style scoped>
.main {
  width: 100%;
  height: calc(100% - 120px);
  overflow: auto;
}
.main::-webkit-scrollbar {
  /*滚动条整体样式*/
  /*高宽分别对应横竖滚动条的尺寸*/
  width: 10px;
  height: 1px;
}
.main::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 8px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  background: #c6cad1;
}

.main::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  /* -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2); */
  border-radius: 8px;
  background: #edeef0;
}
.list-style {
  margin: 0 auto;
  width: 80%;
}

.list-style .list-header {
  color: #11254a;
}

.list-style ul {
  display: flex;
  /* background: #f5f5f5; */
  justify-content: space-around;
  min-height: 50px;
  align-items: center;
}
.list-style li {
  flex: 1;
  text-align: center;
  word-break: break-all;
}
.list-style > :first-child {
  display: flex;
  background: #f5f5f5;
  justify-content: space-around;
  color: #3d4d6b;
  font-size: 15px;
  font-weight: 500;
  min-height: 50px;
  align-items: center;
  border-radius: 3px;
}

/* 奇数行的样式 */
.list-style div:nth-child(odd) {
  background: #f5f5f5;
  border-radius: 8px;
}
/* 偶数行的样式 */
/* .list-style div:nth-child(even) { */
/* background: #ffffff; */
/* } */
.title {
  padding: 30px 0px 20px 0px;
  color: #11254a;
  font-size: 20px;
  font-weight: 500;
  width: 80%;
  text-align: center;
  display: flex;
  justify-content: flex-start; /* adjustment */
  position: relative; /* new */
  margin-left: 10%;
}

.selectedClass {
  background-color: #c6cbd1 !important;
  padding: 0px 10px 10px;
  border-radius: 8px;
}
.selectedClass > ul {
  color: #11254a;
}
.selectedClass > div > ul {
  background: white;
  border-radius: 8px;
  border-bottom: 1px solid #c6cbd1;
}
.selectedClass > div > div {
  background: white;
  border-radius: 8px;
}
.closeDetail {
  background-color: #dddee2;
  border-radius: 8px;
  margin: 1px;
  height: 35px;
  font-size: 14px;
  font-weight: 600;
}

/* 新增样式 */
/* 整理内联样式 */

.list-style-mobile {
  display: none;
}

/*--使用媒体查询--*/
@media (min-width: 747px) {
  .title span {
    flex: 0 1 auto;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}

/*--使用媒体查询--*/
@media (max-width: 1240px) {
  .title span {
    left: 50%;
  }
  .list-style-mobile {
    width: 96%;
    margin: 5px auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .contactDetailDiv {
    background-color: #c6cbd1 !important;
  }
  .list-style-mobile ul {
    margin: 5px auto;
    width: 96%;
    background-color: #f5f5f5;
    border-radius: 8px;
  }

  .list-style-mobile ul li {
    display: flex;
    margin: 0 auto;
    width: 94%;
    justify-content: space-around;
    align-items: center;
    min-height: 32px;
    height: auto;
    line-height: 32px;
    border-bottom: 1px solid #fff;
  }

  .list-style-mobile ul li span:nth-child(1) {
    width: 40%;
    text-align: left;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 400;
  }
  .list-style-mobile ul li span:nth-child(2) {
    width: 60%;
    text-align: left;
    word-break: keep-all;
  }
}
</style>
<script>
export default {
  name: 'Shop',
  data() {
    return {
      dataResult: [],
      loading: false
    };
  },
  computed: {
    selected: function () {
      return function (len, isshow) {
        if (len > 0 && isshow == '1') {
          return 'selectedClass';
        } else {
          return '';
        }
      };
    }
  },
  methods: {
    dataChange() {
      let self = this;
      var shopAndLocationlist = JSON.parse(
        self.$store.getters.get_shop_collection_cache
      );
      if (shopAndLocationlist) {
        shopAndLocationlist.shops.forEach((shop) => {
          let obj = {};
          obj.id = shop.id;
          obj.ShopCode = shop.shopCode;
          obj.ShopNameEN = shop.nameEN;
          obj.ShopNameCH = shop.nameTC;
          switch (shop.shopType) {
            case 0:
              obj.ShopType = 'Mall Shop';
              break;
            case 1:
              obj.ShopType = 'Station Shop';
              break;
            case 2:
              obj.ShopType = '3rd party Shop';
              break;
            case 3:
              obj.ShopType = 'Souvenir Shop';
              break;
          }

          if (shop.shopLocation) {
            let mall = shopAndLocationlist.malls.find(
              (p) => p.id == shop.shopLocation.id
            );
            obj.ShopLocationMall = mall ? mall.name : 'N/A';
            let line = shopAndLocationlist.metroLines.find(function (m) {
              return m.metroStations.find((p) => p.id == shop.shopLocation.id);
            });
            obj.ShopLocationStation = line
              ? line.metroStations.find((p) => p.id == shop.shopLocation.id)
                  .name
              : 'N/A';
          } else {
            obj.ShopLocationStation = 'N/A';
          }

          obj.ExpiryDate = shop.leaseExpireDate ? shop.leaseExpireDate : 'N/A';
          obj.AcceptEvoucher = shop.acceptEVoucher ? 'YES' : 'NO';
          obj.isShowDetailData = '0';
          obj.DetailData = [];
          self.dataResult.push(obj);
        });
      }
    },
    showDetail(id, shopCode) {
      let self = this;
      let url = '/Shop/shopcode/' + shopCode + '/contacts';
      this.$axios
        .get(url)
        .then(function (res) {
          self.dataResult.forEach((element) => {
            if (element.id == id) {
              if (element.isShowDetailData == '0') {
                element.isShowDetailData = '1';
                res.forEach((r) => {
                  r.receiveUsageReport = r.receiveUsageReport ? 'YES' : 'NO';
                });
                element.DetailData = res;
              } else {
                element.isShowDetailData = '0';
              }
            } else {
              element.isShowDetailData = '0';
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downloadCsv() {
      function download(data) {
        if (!data) {
          return;
        }
        let url = window.URL.createObjectURL(
          new Blob(['\uFEFF' + data], { type: 'text/csv;charset=utf-8' })
        );
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', 'Shop Contact.csv');
        document.body.appendChild(link);
        link.click();
      }
      //获取新的shopcollection
      let user = this.$store.getters.get_user_Info_cache;
      if (user) {
        let url = user.isMerchant
          ? '/Shop/downloadShopContactCsv/byMerchant/' + user.merchantId
          : '/Shop/downloadShopContactCsv/byShop/' + user.shopid;
        this.loading = true;
        this.$axios
          .get(url)
          .then(function (data) {
            download(data);
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    }
  },
  mounted: function () {
    this.dataChange();
  }
};
</script>
